import React, { Component } from "react"
import { Link } from "react-router-dom"
import bg from "../img/background.webp"
export default class NotFound extends Component {
  render() {
    return (
      <div>
        <div
          className="full-page"
          style={{
            backgroundImage: "url(" + bg + ")"
          }}
        >
          <div className="container-table col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3">
            <div
              className="card-header text-center"
              data-background-color="as-blue"
            >
              <h1
                style={{
                  color: "white",
                  marginTop: "60%"
                }}
              >
                Erro 403 Você não tem permissão para essa operação
              </h1>
              <Link className="btn btn-default btn-simple btn-wd btn-lg" to="/">
                Retornar para dashboard
              </Link>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PermissionDenied.js